/** `+91 98765 43210` for an Indian mobile number in E.164 form; anything else is shown as it is. */
export function formatPhone(phone: string): string {
  const match = /^\+91(\d{5})(\d{5})$/.exec(phone);
  return match === null ? phone : `+91 ${match[1] ?? ''} ${match[2] ?? ''}`;
}
